var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.00004C0 3.82599 0.0691399 3.65907 0.19221 3.536C0.31528 3.41293 0.482199 3.34379 0.656246 3.34379H11.6724L9.83494 1.63755C9.77174 1.57895 9.72071 1.50847 9.68474 1.43015C9.64878 1.35182 9.6286 1.26718 9.62535 1.18105C9.6221 1.09493 9.63585 1.009 9.6658 0.928191C9.69576 0.847377 9.74134 0.773255 9.79994 0.710057C9.91829 0.582422 10.0825 0.507031 10.2564 0.500467C10.3426 0.497217 10.4285 0.510962 10.5093 0.540919C10.5901 0.570875 10.6642 0.616455 10.7274 0.675057L13.7899 3.51879C13.8562 3.58022 13.909 3.65467 13.9452 3.73748C13.9813 3.8203 14 3.90968 14 4.00004C14 4.09039 13.9813 4.17978 13.9452 4.26259C13.909 4.3454 13.8562 4.41985 13.7899 4.48128L10.7274 7.32502C10.5998 7.44337 10.4304 7.50617 10.2564 7.49961C10.0825 7.49304 9.91829 7.41765 9.79994 7.29002C9.68159 7.16238 9.61879 6.99296 9.62535 6.81902C9.63191 6.64508 9.70731 6.48087 9.83494 6.36252L11.6724 4.65628H0.656246C0.482199 4.65628 0.31528 4.58714 0.19221 4.46407C0.0691399 4.341 0 4.17408 0 4.00004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.56940b17c8cf4b5ccec633fa1d715982.svg";
export { ForwardRef as ReactComponent };